import {
  Box,
  BoxContent,
  Button,
  Columns,
  ColumnsItem,
  RowItem,
  Rows,
  Title,
  TitleLevels,
} from '@bytel/trilogy-react-ts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { VictoryLegend } from 'victory';
import { assets } from '@shared/constants';
import RingChart from '@shared/components/ring-chart';
import PopupTelephonesAchetes from '@shared/components/popup-telephones-achetes';
import useData from './hook';
import { EmpreinteCarboneTelephonesProps } from './type';
import { useEmpreinteCarboneTelFilters } from './filter-hook';
import FilterModal from './filter-modal';

const EmpreinteCarboneTelephones: React.FC<EmpreinteCarboneTelephonesProps> = ({
  data,
}: EmpreinteCarboneTelephonesProps) => {
  const {
    filters: pendingFilters,
    appliedFilters,
    filteredData,
    availableMarques,
    availableModeles,
    updatePendingFilters,
    applyFilters,
    resetFilters,
    hasActiveFilters,
    isFilterModalOpen,
    setIsFilterModalOpen,
  } = useEmpreinteCarboneTelFilters(data);

  const { chartData, chartDataCO2, total, totalCO2, legends, popupData, openPopup, closePopup } = useData(filteredData);

  const { t } = useTranslation('domain/home', {
    keyPrefix: 'consommationTelephone',
  });

  return (
    <>
      {popupData && <PopupTelephonesAchetes data={popupData} onClose={closePopup} />}
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        pendingFilters={pendingFilters}
        appliedFilters={appliedFilters}
        availableMarques={availableMarques}
        availableModeles={availableModeles}
        onUpdatePendingFilters={updatePendingFilters}
        onResetFilters={resetFilters}
        onApplyFilters={applyFilters}
      />
      <Box className="is-fullwidth is-fullheight" data-cy="home-boxTelephonesAchetes">
        <BoxContent className="homeBoxBilanCarbone">
          <Rows>
            <RowItem narrow>
              <Columns verticalCentered>
                <ColumnsItem>
                  <Title level={TitleLevels.THREE} data-cy="boxBilanCarbone-bilan">
                    {t('bilanTitle')}
                  </Title>
                </ColumnsItem>
                <ColumnsItem className="has-text-right">
                  <Button
                    onClick={() => setIsFilterModalOpen(true)}
                    data-cy="telephone-filter-button"
                    className={`${hasActiveFilters ? 'has-text-primary' : ''}`}
                  >
                    <img
                      src={assets.urls.logos.filtres}
                      alt="Filtres"
                      style={{
                        height: '16px',
                        width: '16px',
                        marginRight: '8px',
                      }}
                    />
                    {t('filtreButton')} {hasActiveFilters && '●'}
                  </Button>
                </ColumnsItem>
              </Columns>
            </RowItem>
            <RowItem>
              <Columns className="">
                <ColumnsItem className="is-flex">
                  <RingChart title={t('numberBilanTitle')} valueList={chartData} total={total} onClick={openPopup} />
                </ColumnsItem>
                <ColumnsItem className="is-flex is-fullheight">
                  <RingChart
                    title={t('consommationBilanTitle')}
                    valueList={chartDataCO2}
                    total={Number(totalCO2.value)}
                    centerText={`${totalCO2.value} ${totalCO2.unit}\n Total`}
                    onClick={openPopup}
                  />
                </ColumnsItem>
              </Columns>
            </RowItem>
            <RowItem narrow>
              <svg viewBox="0 0 600 25" className="is-fullwidth">
                <VictoryLegend
                  standalone={false}
                  orientation="horizontal"
                  data={legends}
                  gutter={20}
                  symbolSpacer={5}
                  x={0}
                />
              </svg>
            </RowItem>
          </Rows>
        </BoxContent>
      </Box>
    </>
  );
};
export default EmpreinteCarboneTelephones;
